// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"388":"343cd7e8","515":"0142faa8","980":"343cd7e8"}[chunkId] + ".css";
};